import React from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="tech-leaders-complex">
                <div className="tech-leaders-complex__wrapper">
                    <div className="tech-leaders-complex__wrapper-img">
                        <div className="tech-leaders-complex__img">
                            <img src="/images/svg/tech-leaders/example.svg" alt="" loading="lazy" />
                        </div>
                    </div>
                    <div className="tech-leaders-complex__info-container">
                        <CommonTitle>Сложности</CommonTitle>
                        <CommonSmallText isOneParagraph={false}>
                            Сайт федеральной конференции&nbsp;&mdash; это всегда большой поток
                            информации, сжатые сроки и&nbsp;постоянные изменения контента.
                            В&nbsp;ходе разработки сайта, программа и&nbsp;место проведения менялись
                            несколько раз.
                        </CommonSmallText>
                        <CommonSmallText isOneParagraph={false}>
                            Только на&nbsp;мультиязычную поддержку сайта было потрачено более 400
                            часов наших контент-менеджеров. А&nbsp;в&nbsp;последнюю неделю перед
                            мероприятием команда проекта перешла в&nbsp;режим работы 24/7.
                        </CommonSmallText>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
